import "./cloudflareDeployBump";
import "./index.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import Main from "./Main.tsx";
import { setContextToken } from "routes/home/my-courses/coursesUtils.ts";
import { initNewRelic } from "./common/api/monitoring";
import { setNativeSession } from "common/utils/native.ts";
import { setLocaleOverride } from "./locale/localeOverride.ts";

(function () {
  initNewRelic();
  // Store before My Courses API calls need to access it
  setContextToken();
  setNativeSession();
  setLocaleOverride();
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);
